module.exports = __webpack_public_path__ + "static/taki-183-poster-40c4c0300e64a132afc286b7250ba047.jpg";